// src/components/MainLayout.js
import React from 'react';
import Header from './Header';
import StaffPinGate from './StaffPinGate';
// import Footer from './Footer';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../styles/subtleToast.css';

const MainLayoutWithoutFooter = ({ children, guardedNavigate }) => (
  <>
    <Header guardedNavigate={guardedNavigate}/>
    {children}
    <ToastContainer position="top-right" autoClose={2000} hideProgressBar closeButton={false} theme="dark" />
    <StaffPinGate />
  </>
);

export default MainLayoutWithoutFooter;
